// extracted by mini-css-extract-plugin
module.exports = {"newsAndInsights":"news-and-insights_newsAndInsights__AwVuR"};